var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import { Component } from "vue-property-decorator";
var ReleaseCom = (function (_super) {
    __extends(ReleaseCom, _super);
    function ReleaseCom() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.relShow = false;
        _this.showMask = false;
        _this.customizeStyle = false;
        _this.showClose = false;
        _this.className = 'release-wrapper';
        return _this;
    }
    ReleaseCom.prototype.created = function () {
    };
    ReleaseCom.prototype.mounted = function () {
    };
    ;
    ReleaseCom.prototype.show = function (option) {
        if (option.hasMask) {
            this.showMask = true;
        }
        ;
        if (option.showClose) {
            this.showClose = true;
        }
        this.relShow = true;
        if (option.className) {
            this.className = option.className;
        }
    };
    ;
    ReleaseCom.prototype.hide = function () {
        this.relShow = false;
        this.showMask = false;
    };
    ;
    ReleaseCom = __decorate([
        Component
    ], ReleaseCom);
    return ReleaseCom;
}(Vue));
export default ReleaseCom;
